import { ImageCardProps } from "@components/ComparisonPage/GallaboxSpotlightFeatures";

export const imageCard: ImageCardProps[] = [
    {
        imageUrl: "comparison-page/wa-chatbot-icon.png",
        imageTitle: "WhatsApp Chatbot",
    },
    {
        imageUrl: "comparison-page/shared-team-inbox.png",
        imageTitle: "Shared Team Inbox",
    },
    {
        imageUrl: "comparison-page/wa-broadcast.png",
        imageTitle: "WhatsApp Broadcast",
    },
    {
        imageUrl: "comparison-page/wa-shop.png",
        imageTitle: "WhatsApp Shop",
    },
];
